module.exports = __webpack_public_path__ + "static/media/page-intro-img-2.f904802d.png";